import { render, staticRenderFns } from "./DesignGetStartedIntroduction.vue?vue&type=template&id=45b28f62"
import script from "./DesignGetStartedIntroduction.vue?vue&type=script&lang=js"
export * from "./DesignGetStartedIntroduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports